
import React, { useState } from "react";
import axios from "axios";
import "./Loginn.css";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const REQUEST_OTP_API =
    "https://devskillz-ifm6.onrender.com/api/forgot-password/request-otp";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const res = await axios.post(REQUEST_OTP_API, { email });
      setMessage(res.data.message || "OTP sent to your email.");
    } catch (err) {
      setError(
        err.response?.data?.error || "Failed to send OTP. Try again."
      );
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h2>Forgot Password</h2>
        <p className="subtitle">
          Enter your registered email to receive OTP
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit">Send OTP</button>

          {message && <p style={{ color: "green" }}>{message}</p>}
          {error && <p className="error">{error}</p>}
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
